import { generateURL } from 'utils/helpers';

const product = {
  getProductTypes: () => {
    const url = generateURL('/utility/product_types');
    return fetch(url, {
      method: 'GET',
    }).then((response) => response.json());
  },
};

export default product;
